// Rutele R.E.S.D.P.S.; cheia GET se foloseste pentru toate metodele, dupa conventia modulelor de endpoint-uri.
export default Object.freeze({
  files: {
    GET: () => "succession-files",
  },
  file: {
    GET: (id) => `succession-files/${id}`,
  },
  fileAudit: {
    GET: (id) => `succession-files/${id}/audit`,
  },
  fileAction: {
    GET: (id, action) => `succession-files/${id}/${action}`,
  },
  fileDocuments: {
    GET: (id) => `succession-files/${id}/documents`,
  },
  fileDocument: {
    GET: (id, documentId, action) =>
      `succession-files/${id}/documents/${documentId}/${action}`,
  },
  documentTemplate: {
    GET: (code) => `DocumentTemplates/${code}/effective`,
  },
  documentTemplateVersion: {
    GET: (code, version) =>
      `DocumentTemplates/${code}/versions/${version}/download`,
  },
  register: {
    GET: () => "resdps",
  },
  generalRegistryEntry: {
    GET: () => "resdps/general-registry-entry",
  },
  registries: {
    GET: () => "registries",
  },
  notaryChambers: {
    GET: () => "notary-chambers",
  },
});
